import { TemplateNodeVisitor } from "./nodeVisitor";
import { FormNode, DropdownGroupNode, RadioButtonElementNode, LabelNode, TextBoxNode, CheckboxNode, DateNode, ElementNode, InputNode, ImageNode } from "..";
import moment from "moment";

export class ContextApplicator extends TemplateNodeVisitor {
    constructor(context) {
        super();
        this.context = context;
    }

    private context;

    visitDropdownGroupNode(node: DropdownGroupNode) {
        this.strApplyContext(node);
        this.visitChildren(node);
    }

    visitRadioButtonElementNode(node: RadioButtonElementNode) {
        this.boolApplyContext(node);
        this.visitChildren(node);
    }

    visitLabelNode(node: LabelNode) {
        if (node.text === undefined || node.text === null || node.text === "") {
            node.text = this.getContextValue(node.dynamicName);
        }
        else {
            this.applyTextReplacement(node);
        }
        
        this.visitChildren(node);
    }

    visitTextBoxNode(node: TextBoxNode) {
        this.strApplyContext(node);
        this.visitChildren(node);
    }

    visitCheckboxNode(node: CheckboxNode) {
        this.boolApplyContext(node);
        this.visitChildren(node);
    }

    visitDateNode(node: DateNode) {
        this.dateApplyContext(node);
        this.visitChildren(node);
    }

    visitImageNode(node: ImageNode) {
        this.urlApplyContext(node);
        this.visitChildren(node);
    }

    private strApplyContext(node: InputNode<string>) {
        const val = this.getContextValue(node.dynamicName);

        if (val !== undefined) {
            node.defaultValue = val;
        }
    }

    private boolApplyContext(node: InputNode<boolean>) {
        const val = this.getContextValue(node.dynamicName);

        if (val !== undefined) {
            node.defaultValue = val || val === "true";
        }
    }

    private dateApplyContext(node: InputNode<Date>) {
        const val = this.getContextValue(node.dynamicName);

        if (val !== undefined) {
            node.defaultValue = new Date(val);
        }
    }

    private urlApplyContext(node: ElementNode) {
        const val = this.getContextValue(node.dynamicName);

        if (val !== undefined) {
            node.url = val;
        }
    }

    private getContextValue(dynamicName: string | undefined) {
        if (dynamicName === undefined || dynamicName === null) {
            return undefined;
        }

        const nameSplits = dynamicName.split(".");

        let subContext = this.context;

        for (let p = 0; p < nameSplits.length; p++) {
            let prop = nameSplits[p];
            prop = prop.substring(0, 1).toLowerCase() + prop.substring(1, prop.length);
            if (subContext[prop] !== undefined && subContext[prop] !== null && subContext[prop] !== "") {
                subContext = subContext[prop];
            }
            else {
                subContext = undefined;
            }
        }

        return subContext;
    }

    private applyTextReplacement(node: ElementNode) {
        if (node.text === undefined) {
            return;
        }

        let text = node.text;

        const textMatchExp = new RegExp(/\$\{.*?\}/g);
        const linkMatchExp = new RegExp(/\$\{(.+)\|(.+)\}/);

        const matches = text.match(textMatchExp);
        if (!matches) {
            return;
        }

        matches.forEach(match => {
            let propArray = Array<string>();
            let propText = "";
            let staticText = "";
            let isLinkProp = false;

            const linkMatch = match.match(linkMatchExp);
            if (linkMatch && linkMatch.length === 3) {
                // Format: ${STATIC_TEXT|PROP_TEXT}
                staticText = linkMatch[1];
                propText = linkMatch[2];
                isLinkProp = true;
            } else {
                propText = match.substring(2, match.length - 1);
            }

            propArray = propText.split(".");
            let prevParent = this.context;
            for (let p = 0; p < propArray.length; p++) {
                let prop = propArray[p];
                prop = prop.substring(0, 1).toLowerCase() + prop.substring(1, prop.length);
                if (prevParent[prop] !== undefined && prevParent[prop] !== null && prevParent[prop] !== "") {
                    prevParent = prevParent[prop];
                } else {
                    text = text.replace(match, "");
                    return;
                }
            }

            if (prevParent !== undefined && prevParent !== null) {
                if (typeof prevParent === typeof "") {
                    // Link
                    if (isLinkProp) {
                        prevParent = `<a href=${prevParent}>${staticText}</a>`;
                    }

                    // Date:
                    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(prevParent)) {
                        const format = node.dateFormat && node.dateFormat !== "" ? node.dateFormat : "dddd, MMM Do, YYYY, h:mm a";
                        const dateParse = moment(prevParent).format(format);

                        prevParent = dateParse ?? prevParent;
                    }

                    // Phone Number
                    if(prevParent.length == 10 && /^\d+$/.test(prevParent)) {
                        prevParent = prevParent.substr(0, 3) + "-" + prevParent.substr(3, 3) + "-" + prevParent.substr(6);
                    }
                }

                text = text.replace(match, prevParent);
            }
        });

        node.text = text;
    }
}

export const applyContext = (node: FormNode, context: any) => {
    const applicator = new ContextApplicator(context);
    node.accept(applicator);

    return node;
};